import * as yup from 'yup'
import { MAX_KNOWLEDGEBASE_FILE_SIZE } from 'constants/files'

const KnowledgeBaseFileSchema = yup.mixed()
  .test(
    'fileSize',
    'common.errors.kbFileSize',
    (value) => value === null || value?.size <= MAX_KNOWLEDGEBASE_FILE_SIZE
  )

export { KnowledgeBaseFileSchema }
